// extracted by mini-css-extract-plugin
export default {"rightIconColor":"qwqfq6C3QtPQxkXqSdG8","settingsPopup":"C1D3OFU2h4VKHGRtIgfd"};